import { useState, useEffect, useRef } from 'react';

export function InfoTooltip({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);

  const toggleTooltip = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-50" ref={tooltipRef}>
      <button
        type="button"
        className="inline-flex items-center justify-center w-12 h-12 text-sm font-semibold rounded-full border border-gray-200 bg-white text-gray-600 shadow-xs hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 focus:ring-offset-white transition-all"
        onClick={toggleTooltip}
      >
        <span className="sr-only">Help</span>
        <svg
          className="shrink-0 w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          width="28.8"
          height="28.8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
      </button>
      {isOpen && (
        <div
          className="absolute bottom-full right-0 mb-2 py-3 px-4 bg-white border text-md text-gray-600 rounded-lg shadow-md w-96"
          role="tooltip"
        >
          {children}
        </div>
      )}
    </div>
  );
}
